import { fetcher } from '@commenda/utils';
import { API_BASE_PATH } from './constants';

type TUpdateAgentFirmUserDTO = {
  id: string;
  isArchived: boolean;
};

export async function updateAgentFirmUser(
  data: TUpdateAgentFirmUserDTO
): Promise<{ success: boolean; error: string | null }> {
  const query = new URLSearchParams();
  if (data.id) {
    query.append('id', data.id);
  }

  try {
    const res = await fetcher(
      `${API_BASE_PATH}/update?${query}`,
      {
        method: 'POST',
        body: { isArchived: data.isArchived },
      },
      undefined
    );

    if (!res.ok) {
      return {
        success: false,
        error: 'An error occurred while updating the agent firm user.',
      };
    }

    return {
      success: true,
      error: null,
    };
  } catch (err) {
    return {
      success: false,
      error:
        err instanceof Error ? err.message : 'An unexpected error occurred',
    };
  }
}
